import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import {
	get as _get,
	keys as _keys,
} from 'lodash';
import { User, UserCommunityAssignation } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
import { tolerateNotificationFailure } from '@app-shared/utils/follow-up-notification';
@Injectable()
export class UsersService {
	users: User[] = [];
	startDate: any = new Date();
	endDate: any = new Date();
	public setDateRangeSub = new Subject<any>();
	private observable = new Observable()
	private tabledatasource = new BehaviorSubject('No table data service');
	currentMessagetable = this.tabledatasource.asObservable();
	private carddatasource = new BehaviorSubject('default message');
	currentMessagecard = this.carddatasource.asObservable();
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	changeMessagecard(carddata: any) {
		this.carddatasource.next(carddata)
	}
	changeMessagetable(tabledata: any) {
		this.tabledatasource.next(tabledata)
	}
	getqualtitycontrolvalues(uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('uuid', `${uuid}`);
		return this._httpClient.get(`${APIs.users}/getqualticontrol`, { headers: headers, params: params });
	}
	getUsersData() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}`, { headers: headers });
	}
	getUsersApplication(uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('uuid', `${uuid}`);
		return this._httpClient.get(`${APIs.users}/getUserApplication`, { headers: headers, params: params });
	}
	getUsersArcApplication(uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('uuid', `${uuid}`);
		return this._httpClient.get(`${APIs.users}/getUserArcApplication`, { headers: headers, params: params });
	}
	resendUserApplicationReference(data) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.users}/resendUserApplicationReference`, data, { headers: headers, });
	}
	AddTestimonyComment(data) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.users}/add_testimony_comment`, data, { headers: headers, });
	}
	getUsersWithStats(startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('start_date', `${startDate}`);
		params = params.set('end_date', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/with_stats`, { headers: headers, params: params });
	}
	getUsersWithStatsTotals(params: HttpParams) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/with_stats_totals`, { headers: headers, params: params });
	}
	getCommunitiesWithStatsTotals(params: HttpParams) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/getcldashboardtotals`, { headers: headers, params: params });
	}
	getUsersWithtotalStats(startdate = null, enddate = null, viewAsRole = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		let url = `${APIs.users}/with_total_stats`;
		if (viewAsRole) {
			url += `?viewAsRole=${viewAsRole}`;
		}
		if (startdate && enddate) {
			params = params.set('startdate', `${startdate}`);
			params = params.set('enddate', `${enddate}`);
			return this._httpClient.get(url, { headers: headers, params: params });
		} else {
			return this._httpClient.get(url, { headers: headers });
		}
	}
	getUsers(uuid: string, filters: string[], sorts: string, order: string, skip: number, take: number) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		if (skip)
			params = params.set('skip', `${skip}`);
		if (take)
			params = params.set('take', `${take}`);
		if (sorts)
			params = params.set('_sort', sorts);
		if (order)
			params = params.set('_order', order);
		_keys(filters).forEach(k => {
			params = params.set(`${k}_like`, filters[k]);
		});
		let api = APIs.users;
		if (uuid)
			api += '/' + uuid;
		return this._httpClient.get(api, { headers: headers, params: params });
	}
	getUser(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/${uuid}`, { headers: headers });
	}
	getUserProfileFull(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/${uuid}/full`, { headers: headers  });
	}
	getUsertestimoney(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/${uuid}/testimonies`, { headers: headers });
	}
	getOmUsers() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/with_stats`, { headers: headers });
	}
	getUserCalendarItems(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/calendar-items/${uuid}`, { headers: headers });
	}
	getUserStatistics(uuid: string, startDate, endDate) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/${uuid}/statistics`, { headers: headers, params: params });
	}
	getUserStats(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/${uuid}/stats`, { headers: headers });
	}
	getUserTasks(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/${uuid}/tasks`, { headers: headers, params: params });
	}
	getUserTrainings(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/${uuid}/trainings`, { headers: headers, params: params });
	}
	getUserTraining(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		return this._httpClient.get(`${APIs.users}/training/${uuid}`, { headers: headers, params: params });
	}
	updateUserTraining(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		return this._httpClient.get(`${APIs.users}/training-status/${uuid}`, { headers: headers, params: params });
	}
	insertUser(body: User) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.users, body, { headers: headers });
	}
	updateUser(body: any, uuid: string) {
		console.log("body ", body)
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.users + '/' + uuid, body, { headers: headers });
	}
	deleteUser(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.users}/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	getTrainingscommunity() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_trainings;
		return this._httpClient.get(`${api}/communities`, { headers: headers });
	}
	UpdateOmCategory(body: User) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.assign_categories, body, { headers: headers });
	}
	//returning null
	getUserQualityConversations(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/${uuid}/quality-conversations`, { headers: headers, params: params });
	}
	getUserConversations(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users}/${uuid}/conversations`, { headers: headers, params: params });
	}
	getConversationsmessages(uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.users}/${uuid}/getconversationsmsg`, { headers: headers });
	}
	getqcs(uuid, body) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.users}/${uuid}/updateqcs`, body, { headers: headers });
	}
	insertUserConversationComment(user_uuid: string, body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.users}/${user_uuid}/conversation_comments`, body, { headers: headers });
	}
	updateUserConversationComments(user_uuid: string, uuid: string, body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.users}/${user_uuid}/conversation_comments/${uuid}`, body, { headers: headers });
	}
	//Update Task Dummy Service
	updateUserTask(body: any, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.users}/update-task/${uuid}`, body, { headers: headers });
		//	return this._httpClient.post(`${APIs.users}/${user_uuid}/tasks/${uuid}`, {headers: headers});
		// let api = APIs.users + '/tasks'
		// return this._httpClient.post(api, body, {headers: headers});
	}
	updateUserTrainingStatus(body: any, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.users}/update-user-training-status/${uuid}`, body, { headers: headers });
	}
	deleteUserConversationComments(user_uuid: string, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.users}/${user_uuid}/conversation_comments/${uuid}`, { headers: headers });
	}
	deleteUserConversations(user_uuid: string, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.users}/${user_uuid}/conversations/${uuid}`, { headers: headers });
	}
	deleteUserTask(user_uuid: string, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.users}/${user_uuid}/tasks/${uuid}`, { headers: headers });
	}
	getUserCommunities(user_uuid: string = null, community_uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.user_community_assignations;

		let params: HttpParams = new HttpParams;
		if (user_uuid)
			params = params.set('user_uuid', user_uuid);
		if (community_uuid)
			params = params.set('community_uuid', community_uuid);
		return this._httpClient.get(api, { headers: headers, params: params });
	}
	insertUserCommunity(body: UserCommunityAssignation) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.user_community_assignations, body, { headers: headers });
	}
	updateUserCommunities(body: UserCommunityAssignation) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(APIs.user_community_assignations, body, { headers: headers });
	}
	deleteUserCommunities(user_uuid: string = null, community_uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		if (user_uuid)
			params = params.set('user_uuid', user_uuid);
		if (community_uuid)
			params = params.set('community_uuid', community_uuid);
		const api = `${APIs.user_community_assignations}`;
		return this._httpClient.delete(api, { headers: headers, params: params });
	}
	getUserNotes(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users_notes}/${uuid}`, { headers: headers, params: params });
	}
	insertNotes(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.users_notes, body, { headers: headers });
	}
	// add new notes
	addNotes(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.users_notes + '/add', body, { headers: headers });
	}
	updateNotes(body: any, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(APIs.users_notes + '/' + uuid, body, { headers: headers });
	}
	insertTask(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.users + '/tasks'
		return this._httpClient.post(api, body, { headers: headers });
	}
	// Assign multiselect conversations to user
	assignMultipleSeeker(body: any, om_uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.seekers}/multi_assign/${om_uuid}`, body, { headers: headers });
	}
	getCountries() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.crm_settings}/countries`, { headers: headers });
	}
	getCountriesTranslation(user_uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.crm_settings}/get-country-translation?uuid=${user_uuid}`, { headers: headers });
	}
	sendnotificationtoom(body) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = `${APIs.notification}/`;
		// let body;
		// if (conversation_uuid) {
		// 	body = {
		// 		data: {
		// 			receiver_system: receiver_system,
		// 			sender_system: sender_system,
		// 			receiver_uuid: receiver_uuid,
		// 			sender_uuid: sender_uuid,
		// 			type: type
		// 		},
		// 		other_data: {
		// 			body: title,
		// 			conversation_uuid: conversation_uuid
		// 		}
		// 	}
		// } else {
		// 	body = {
		// 		data: {
		// 			receiver_system: receiver_system,
		// 			sender_system: sender_system,
		// 			receiver_uuid: receiver_uuid,
		// 			sender_uuid: sender_uuid,
		// 			type: type
		// 		},
		// 		other_data: {
		// 			body: title
		// 		}
		// 	}
		// }
		// A failed follow-up notification must not strand the save that triggered it.
		return this._httpClient.post(api, body, { headers: headers })
			.pipe(tolerateNotificationFailure());
	}
	getoms(username = null, name = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);

		if (username) {
			return this._httpClient.get(`${APIs.oms}?username_like=${username}`, { params: { type: 'A' }, headers: headers });

		}
		if (name) {
			return this._httpClient.get(`${APIs.oms}?name_like=${name}`, { params: { type: 'A' }, headers: headers });

		}

	}
	getLanguages() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.crm_languages}`, { headers: headers });
	}
	sendNotificationwithLanguage(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.crm_languages}/users`, body, { headers: headers });
	}
	getNotificationwithLanguage() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.notification}/announcement`, { headers: headers });
	}
	sendNotification(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.crm_communities}/users`, body, { headers: headers });
	}
	getNotification() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.notification}/cm-notification`, { headers: headers });
	}
	getProfileControls() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.users + '/profile-controls';
		return this._httpClient.get(`${api}`, { headers: headers });
	}
	updateUserProfileControl(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.users + '/profile-controls';
		return this._httpClient.post(`${api}`, body, { headers: headers });
	}
	getUserProfileNotes(uuid: string, startDate = null, endDate = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let params: HttpParams = new HttpParams;
		params = params.set('startDate', `${startDate}`);
		params = params.set('endDate', `${endDate}`);
		return this._httpClient.get(`${APIs.users_profile_notes}/${uuid}`, { headers: headers, params: params });
	}
	updateUserProfileNotes(body: any, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(APIs.users_profile_notes + '/' + uuid, body, { headers: headers });
	}
	insertUserProfileNotes(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.users_profile_notes, body, { headers: headers });
	}
    insertReactivatedUser(body: any) {
        const headers = this._httpHeaderService.getHttpHeader();
        if (!headers)
            return of(null);
        return this._httpClient.post(APIs.reactivations, body, { headers: headers });
    }
	delistARecentDeactivatedUser(uuid: string) {
        const headers = this._httpHeaderService.getHttpHeader();
        if (!headers)
            return of(null);
		const api = `${APIs.reactivations}/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
    }

	async placeOmsInBulkSequentially(om_uuid: string, traineeStatus: string): Promise<any> {
		try {
		  const headers = this._httpHeaderService.getHttpHeader();
		  if (!headers) return Promise.resolve();

		  let apiUrl = APIs.placeOmsOneByOne;
		  if(traineeStatus === 'w'){
			apiUrl = APIs.placeOmsOneByOneStatusWithdrawn;
		  }else if(traineeStatus === 'f'){
			apiUrl = APIs.placeOmsOneByOneStatusFailed;
		  }
	  
		  return new Promise((resolve, reject) => {
			this._httpClient.post(`${apiUrl}/${om_uuid}`, {}, { headers: headers })
			  .subscribe({
				next: response => {
				  resolve(response); 
				},
				error: error => {
				  console.error(`Error posting OM:`, error);
				  reject(error);
				}
			  });
		  });
		} catch (error) {
		  console.error(`Error preparing request for OM:`, error);
		  return Promise.reject(error);
		}
	  }

	getTraineesReadyForPlacement(language: string){
		const headers = this._httpHeaderService.getHttpHeader();
        if (!headers)
            return of(null);
        return this._httpClient.get(APIs.getTraineesReadyForPlacement+'/'+language, { headers: headers })
	}

	getTraineesWithdrawn(language: string){
		const headers = this._httpHeaderService.getHttpHeader();
        if (!headers)
            return of(null);
        return this._httpClient.get(APIs.getTraineesWithdrawn+'/'+language, { headers: headers })
	}

	getTraineesFailed(language: string){
		const headers = this._httpHeaderService.getHttpHeader();
        if (!headers)
            return of(null);
        return this._httpClient.get(APIs.getTraineesFailed+'/'+language, { headers: headers })
	}
}
